var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "spinner" } },
    [
      _c("div", { staticClass: "spinner-bg" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 100 100",
              preserveAspectRatio: "xMidYMid meet",
              width: "100%",
              height: "100%"
            }
          },
          [
            _c("image", {
              ref: "fw1",
              staticClass: "animated-component",
              attrs: {
                x: "5",
                y: "-20",
                width: "16",
                height: "16",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-firework.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              ref: "fw2",
              staticClass: "animated-component",
              attrs: {
                x: "80",
                y: "0",
                width: "16",
                height: "16",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-firework.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              ref: "fs1",
              staticClass: "animated-component",
              attrs: {
                x: "4",
                y: "80",
                width: "18",
                height: "18",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-free-service.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              attrs: {
                x: "72",
                y: "90",
                width: "14",
                height: "14",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-discount.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              attrs: {
                x: "88",
                y: "92",
                width: "14",
                height: "14",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-coin-alt.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              attrs: {
                x: "60",
                y: "102",
                width: "14",
                height: "14",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-starbuck.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              attrs: {
                x: "80",
                y: "98",
                width: "14",
                height: "14",
                transform: "rotate(25 75 105)",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-grab.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              ref: "gift1",
              staticClass: "animated-component",
              attrs: {
                x: "4",
                y: "98",
                width: "30",
                height: "30",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gift.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              ref: "star1",
              staticClass: "animated-component",
              attrs: {
                x: "80",
                y: "-20",
                width: "8",
                height: "8",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              ref: "star2",
              staticClass: "animated-component",
              attrs: {
                x: "0",
                y: "84",
                width: "8",
                height: "8",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              ref: "star3",
              staticClass: "animated-component",
              attrs: {
                x: "34",
                y: "98",
                width: "8",
                height: "8",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              ref: "star4",
              staticClass: "animated-component",
              attrs: {
                x: "94",
                y: "86",
                width: "8",
                height: "8",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg"
              }
            }),
            _vm._v(" "),
            _c("image", {
              ref: "star5",
              staticClass: "animated-component",
              attrs: {
                x: "72",
                y: "101",
                width: "8",
                height: "8",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-star.svg"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title-container" }, [
        _c("svg", { attrs: { "view-box": "0 0 440 120" } }, [
          _c("image", {
            attrs: {
              width: "100%",
              height: "100%",
              href:
                "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/campaign-title.svg"
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wheel" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox:
                "0 0 " +
                (_vm.wheel.diameter + _vm.wheel.strokeWidth * 2) +
                " " +
                (_vm.wheel.diameter + _vm.wheel.strokeWidth * 2),
              width: _vm.wheel.diameter + _vm.wheel.strokeWidth * 2,
              height: _vm.wheel.diameter + _vm.wheel.strokeWidth * 2,
              preserveAspectRatio: "xMidYMid meet"
            }
          },
          [
            _c("g", [
              _c("circle", {
                attrs: {
                  cx: _vm.wheel.cx,
                  cy: _vm.wheel.cy,
                  r: _vm.wheel.diameter * 0.5,
                  stroke: "#97C9D1",
                  "stroke-width": _vm.wheel.strokeWidth
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "g",
              {
                ref: "wheel",
                attrs: { "transform-origin": _vm.wheel.cx + " " + _vm.wheel.cy }
              },
              _vm._l(_vm.sectors, function(award, index) {
                return _c("g", { key: index, staticClass: "sector" }, [
                  _c("path", {
                    staticClass: "sector__figure",
                    attrs: {
                      d: _vm.describeSector(index),
                      fill: _vm.getSectorFill(index),
                      "fill-rule": "evenodd"
                    }
                  }),
                  _vm._v(" "),
                  _c("image", {
                    staticClass: "sector__img",
                    style: _vm.describeImage(index).style,
                    attrs: {
                      x: _vm.describeImage(index).x - 30,
                      y: _vm.describeImage(index).y - 20,
                      href: award.icon_url,
                      width: "60",
                      height: "60"
                    }
                  })
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("image", {
              staticStyle: { cursor: "pointer" },
              attrs: {
                x: _vm.wheel.cx - 60,
                y: _vm.wheel.cy - 60,
                width: "120",
                height: "120",
                href:
                  "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-start.svg"
              },
              on: { click: _vm.spin }
            }),
            _vm._v(" "),
            _c(
              "svg",
              {
                attrs: {
                  width: "50",
                  height: "44",
                  x: _vm.wheel.cx - 25,
                  y: 0,
                  viewBox: "0 0 50 44",
                  fill: "none"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M28.4641 42C26.9245 44.6667 23.0755 44.6667 21.5359 42L0.751282 5.99999C-0.788319 3.33333 1.13618 -6.56032e-06 4.21539 -6.82951e-06L45.7846 -1.04636e-05C48.8638 -1.07328e-05 50.7883 3.33332 49.2487 5.99999L28.4641 42Z",
                    fill: "url(#paint0_linear_19_815)"
                  }
                }),
                _vm._v(" "),
                _c(
                  "defs",
                  [
                    _c(
                      "linearGradient",
                      {
                        attrs: {
                          id: "paint0_linear_19_815",
                          x1: "25",
                          y1: "-16",
                          x2: "25",
                          y2: "48",
                          gradientUnits: "userSpaceOnUse"
                        }
                      },
                      [
                        _c("stop", { attrs: { "stop-color": "#3E678F" } }),
                        _vm._v(" "),
                        _c("stop", {
                          attrs: { offset: "1", "stop-color": "#3580A9" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "campaign-button-container" }, [
        _c("div", { staticClass: "ticket-button bt" }, [
          _vm._v(
            "วันนี้คุณมีสิทธิ์เล่นเกม " +
              _vm._s(_vm.remainingTickets) +
              " สิทธิ์"
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "campaign-button b1",
            on: {
              click: function($event) {
                return _vm.openTermModal()
              }
            }
          },
          [_vm._v("เงื่อนไขกิจกรรม")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "campaign-button b2",
            on: {
              click: function($event) {
                return _vm.openRedeemedRewardsModal()
              }
            }
          },
          [_vm._v("รางวัลของฉัน")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "campaign-button b3",
            on: {
              click: function($event) {
                return _vm.contactAdmin()
              }
            }
          },
          [_vm._v("ติดต่อแอดมิน")]
        )
      ]),
      _vm._v(" "),
      _c(
        "sweet-modal",
        { ref: "userDataModal", attrs: { "overlay-theme": "dark" } },
        [
          _c("div", { staticClass: "user-data-modal-content" }, [
            _c("h2", [_vm._v("กรุณากรอกข้อมูล")]),
            _vm._v(" "),
            _c("h3", [_vm._v("เพื่อหมุนวงล้อรับของแถม")]),
            _vm._v(" "),
            _c("div", { staticClass: "user-data-modal-progress" }, [
              _c("div", { staticClass: "progress" }),
              _vm._v(" "),
              _c("div", { staticClass: "dashed-line" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "progress",
                class: { gray: !_vm.isBirthdayValid }
              })
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submitUserData.apply(null, arguments)
                  }
                }
              },
              [
                _c("label", [
                  _vm._v("\n            เลือกเพศของคุณ\n            "),
                  _vm.gender === null
                    ? _c("img", {
                        staticClass: "check",
                        attrs: {
                          src:
                            "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-check-disabled.png"
                        }
                      })
                    : _c("img", {
                        staticClass: "check",
                        attrs: {
                          src:
                            "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-check.png"
                        }
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "gender-selection" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gender,
                          expression: "gender"
                        }
                      ],
                      attrs: { type: "radio", id: "male" },
                      domProps: { value: 1, checked: _vm._q(_vm.gender, 1) },
                      on: {
                        change: function($event) {
                          _vm.gender = 1
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "gender-option",
                        class: { selected: _vm.gender === 1 },
                        attrs: { for: "male" }
                      },
                      [
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src:
                                "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gender-male.png",
                              alt: "Male"
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gender,
                          expression: "gender"
                        }
                      ],
                      attrs: { type: "radio", id: "female" },
                      domProps: { value: 2, checked: _vm._q(_vm.gender, 2) },
                      on: {
                        change: function($event) {
                          _vm.gender = 2
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "gender-option",
                        class: { selected: _vm.gender === 2 },
                        attrs: { for: "female" }
                      },
                      [
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src:
                                "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gender-female.png",
                              alt: "Female"
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gender,
                          expression: "gender"
                        }
                      ],
                      attrs: { type: "radio", id: "lgbt" },
                      domProps: { value: 3, checked: _vm._q(_vm.gender, 3) },
                      on: {
                        change: function($event) {
                          _vm.gender = 3
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "gender-option",
                        class: { selected: _vm.gender === 3 },
                        attrs: { for: "lgbt" }
                      },
                      [
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src:
                                "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gender-lgbt.png",
                              alt: "Lgbt"
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gender,
                          expression: "gender"
                        }
                      ],
                      attrs: { type: "radio", id: "unspecific" },
                      domProps: { value: 0, checked: _vm._q(_vm.gender, 0) },
                      on: {
                        change: function($event) {
                          _vm.gender = 0
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "gender-option",
                        class: { selected: _vm.gender === 0 },
                        attrs: { for: "unspecific" }
                      },
                      [
                        _c("div", [
                          _c("img", {
                            attrs: {
                              src:
                                "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-gender-other.png",
                              alt: "Unspecific"
                            }
                          })
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("label", [
                  _vm._v("\n            วันเดือนปีเกิด\n            "),
                  !_vm.isBirthdayValid
                    ? _c("img", {
                        staticClass: "check",
                        attrs: {
                          src:
                            "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-check-disabled.png"
                        }
                      })
                    : _c("img", {
                        staticClass: "check",
                        attrs: {
                          src:
                            "https://beneat.s3.ap-southeast-1.amazonaws.com/images/campaign/million-booking-celebrate/icon-check.png"
                        }
                      }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.birthday,
                        expression: "birthday"
                      }
                    ],
                    staticClass: "birthday-input",
                    attrs: { type: "text", placeholder: "ตัวอย่าง 07032541" },
                    domProps: { value: _vm.birthday },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.birthday = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "submit-button",
                    attrs: {
                      type: "submit",
                      disabled: _vm.gender === null || !_vm.isBirthdayValid
                    }
                  },
                  [_vm._v("หมุนวงล้อ")]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "sweet-modal",
        { ref: "rewardModal", attrs: { "overlay-theme": "dark" } },
        [
          _vm.currentReward
            ? _c("div", { staticClass: "reward-modal-content" }, [
                _c("h2", [_vm._v("รางวัลของคุณคือ")]),
                _vm._v(" "),
                _c("div", { staticClass: "reward-code" }, [
                  _vm._v("\n          Code: "),
                  _c("strong", [_vm._v(_vm._s(_vm.currentReward.reward_code))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "reward-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        viewBox: "0 0 300 300",
                        preserveAspectRatio: "xMidYMid meet",
                        width: "300",
                        height: "300"
                      }
                    },
                    [
                      _c("image", {
                        attrs: {
                          x: "0",
                          y: "0",
                          width: "300",
                          height: "300",
                          href: _vm.currentReward.image
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("h1", [_vm._v(_vm._s(_vm.currentReward.title))]),
                _vm._v(" "),
                _c("div", { staticClass: "reward-description" }, [
                  _vm._v(
                    "\n          สามารถใช้รางวัลนี้ตามเงื่อนไขที่กำหนด\n        "
                  )
                ])
              ])
            : _c("div", { staticClass: "reward-modal-content" }, [
                _c("h2", [_vm._v("เกิดข้อผิดพลาด")])
              ])
        ]
      ),
      _vm._v(" "),
      _c(
        "sweet-modal",
        { ref: "redeemedRewardsModal", attrs: { "overlay-theme": "dark" } },
        [
          _c(
            "div",
            { staticClass: "redeemed-rewards-modal-content" },
            [
              _c("h2", [_vm._v("รางวัลของฉัน")]),
              _vm._v(" "),
              _vm.redeemedRewards && _vm.redeemedRewards.length
                ? _vm._l(_vm.redeemedRewards, function(reward) {
                    return _c(
                      "div",
                      { key: reward.id, staticClass: "redeemed-reward-card" },
                      [
                        _c(
                          "div",
                          { staticClass: "redeemed-reward-card-content" },
                          [
                            _c(
                              "div",
                              { staticClass: "redeemed-reward-card-icon" },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      viewBox: "0 0 80 80",
                                      preserveAspectRatio: "xMidYMid meet",
                                      width: "80",
                                      height: "80"
                                    }
                                  },
                                  [
                                    _c("image", {
                                      attrs: {
                                        x: "0",
                                        y: "0",
                                        width: "80",
                                        height: "80",
                                        href: reward.reward.image_alt
                                      }
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "redeemed-reward-card-detail" },
                              [
                                _c("div", { staticClass: "title" }, [
                                  _c("h3", [
                                    _vm._v(_vm._s(reward.reward.title))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "redeemed-reward-card-footer"
                                  },
                                  [
                                    _vm._v(
                                      "ใช้รางวัลได้ที่แอปพลิเคชันหรือตามที่เงื่อนไขกำหนด"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  })
                : [_c("span", [_vm._v("คุณยังไม่มีรางวัล")])]
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "sweet-modal",
        { ref: "termModal", attrs: { "overlay-theme": "dark" } },
        [
          _c("div", { staticClass: "term-modal-content" }, [
            _c("h2", [_vm._v("เงื่อนไขกิจกรรม")]),
            _vm._v(" "),
            _c("div", { staticClass: "term" }, [
              _c("div", { staticClass: "term-subtitle" }, [
                _vm._v("\n            วิธีเข้าร่วมสนุก\n          ")
              ]),
              _vm._v(" "),
              _c("ol", [
                _c("li", [_vm._v("เพียงจองและใช้บริการในแอปพลิเคชั่น BeNeat")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "คุณจะได้รับสิทธิ์ทุกการใช้บริการ 1 สิทธิ์หมุนวงล้อ ต่อ 1 การให้บริการที่เสร็จสิ้นแล้ว"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("โดยเปิดแอปพลิเคชั่น BeNeat และไปที่แบนเนอร์ "),
                  _c("strong", [_vm._v("“กิจกรรมหมุนวงล้อ รับของแถม”")])
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("คุณจะได้รับรางวัลทุกครั้งที่หมุน ")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "ร่วมสนุกได้ตั้งแต่ วันที่ 28 มิถุนายน - 22 สิงหาคม 2567"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "term-subtitle" }, [
                _vm._v("\n            รายละเอียดของรางวัล\n          ")
              ]),
              _vm._v(" "),
              _c("ol", [
                _c("li", [_vm._v("ทำความสะอาดฟรี 2 ชม. มูลค่า 556.40 บาท")]),
                _vm._v(" "),
                _c("li", [_vm._v("GrabGifts Card มูลค่า 200 บาท")]),
                _vm._v(" "),
                _c("li", [_vm._v("Starbucks Card E-Coupon มูลค่า 100 บาท")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "ส่วนลด Coin มูลค่า 5 Coin, 10 Coin, 20 Coin, 50 Coin และ 100 Coin"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "ส่วนลดบริการ BeNeat 3%, 5%, 7%, 10%, 15%, 20% (สามารถใช้ได้ทุกบริการในแอปพลิเคชั่น BeNeat)"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "term-subtitle" }, [
                _vm._v(
                  "\n            เงื่อนไขการร่วมสนุกลุ้นรับรางรางวัล\n          "
                )
              ]),
              _vm._v(" "),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "ผู้ที่ใช้บริการแอปพลิเคชัน BeNeat หลังจากเสร็จสิ้นการให้บริการ จะได้รับ 1 สิทธิ์ ต่อ 1 การใช้บริการในการหมุนวงล้อ"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("\n              บริการที่เข้าร่วม\n              "),
                  _c("ul", [
                    _c("li", [_vm._v("บริการทำความสะอาดรายชั่วโมง")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("บริการรีดผ้า")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("บริการทำความสะอาดห้องน้ำ")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("บริการทำความสะอาดทีม 3 คน")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("บริการนวด")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("บริการกำจัดไรฝุ่น")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("บริการ Big Cleaning")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("บริการซักโซฟา ที่นอน ผ้าม่าน")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("บริการพ่นฆ่าเชื้อ")])
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "กรณีที่ได้รับรางวัลเป็นบริการทำความสะอาดฟรี 2 ชม. รายละเอียดการจองจะถูกส่งเข้าไปที่อีเมล์ที่ผู้โชคดีลงทะเบียนผ่านแอปไว้ และการจองจะปรากฏในหน้าใบงานในแอปของผู้โชคดีด้วย"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "กรณีที่ได้รับเป็น GrabGifts Card และ Starbucks Card E-Coupon ทางบริษัทจะดำเนินการส่ง Link E-Coupon ให้กับท่านผ่านช่องทาง Email และ Line ที่ลงทะเบียนไว้กับ BeNeat"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "กรณีที่ได้รับเป็นส่วนลด Coin และ ส่วนลดค่าบริการ BeNeat ผู้โชคดีจะได้รับผ่านแอปพลิเคชั่น BeNeat ทันทีในหน้าโปรไฟล์ หลังจากกดออกจากหน้ากิจกรรม"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "ท่านสามารถเช็คของรางวัลที่ได้รับทั้งหมดจากกิจกรรมร่วมสนุก หมุนวงล้อ รับของแถม ได้ที่หน้ากิจกรรม และไปที่รางวัลของฉัน หรือสามารถติดต่อทางแอดมินเพื่อสอบถามเพิ่มเติมได้ที่ Line Official : @BeNeat"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "บริษัทขอสงวนสิทธิ์ในการระงับหรือยกเลิกการให้สิทธิ์หรือรางวัลใด ๆ ในกิจกรรมนี้แก่บุคคลที่กระทำการใด ๆ โดยทุจริตหรือผิดกฎหมายหรือไม่ดำเนินการตามที่ระบุไว้ในเงื่อนไขและข้อกำหนดของกิจกรรมหรือเงื่อนไขอื่น ๆ ที่เกี่ยวข้องกับการใช้บริการแอปพลิเคชัน BeNeat หรือกระทำการใด ๆ อันเป็นการผิดวัตถุประสงค์ของกิจกรรม"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "บริษัทมีสิทธิ์แต่เพียงผู้เดียวในการเพิกถอน เปลี่ยนแปลง และ/หรือ แก้ไขข้อกำหนดและเงื่อนไขของกิจกรรมนี้ได้ตลอดเวลา ซึ่งรวมถึงแต่ไม่จำกัดเพียงการเลื่อนหรือยกเลิกกิจกรรม โดยไม่จำเป็นต้องแจ้งให้ผู้เข้าร่วมกิจกรรมทราบล่วงหน้า และผู้เข้าร่วมกิจกรรมตกลงยอมรับเงื่อนไขการเปลี่ยนแปลงดังกล่าว"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "บริษัทไม่ต้องรับผิดชอบต่อความเสียหาย การสูญเสีย การได้รับบาดเจ็บ หรือความผิดหวังที่เกิดขึ้นอันเนื่องมาจากการเข้าร่วมกิจกรรมหรือการรับมอบรางวัล หรือความเสียหายอื่นใดที่เกิดจากหรือเกี่ยวข้องกับกิจกรรมนี้ต่อผู้เข้าร่วมกิจกรรมหรือบุคคลที่สามไม่ว่ากรณีใด ๆ"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "บริษัทจะไม่รับผิดชอบต่อการสูญหายหรือการถูกโจรกรรมข้อมูลของผู้เข้าร่วมกิจกรรม อันเนื่องมาจากปัญหาของระบบและ/หรือปัญหาทางเทคนิค รวมถึงแต่ไม่จำกัดเฉพาะการกระทำความผิดของบุคคลที่สาม"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "รางวัลไม่สามารถขาย โอน หรือมอบสิทธิ์ให้แก่บุคคลหรือนิติบุคคลอื่นได้ และไม่สามารถเปลี่ยนเป็นเงินสดหรือสิ่งของอย่างอื่นได้ ไม่ว่ากรณีใด ๆ ทั้งสิ้น"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "ข้อกำหนดและเงื่อนไขนี้อยู่ภายใต้บังคับของกฎหมายประเทศไทย และข้อพิพาทใด ๆ ที่เกิดขึ้นอันเกี่ยวกับข้อกำหนดและเงื่อนไขนี้จะอยู่ในเขตอำนาจของศาลไทย"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "กรณีมีข้อพิพาทใด ๆ เกี่ยวกับกิจกรรมนี้ การพิจารณาและคำตัดสินของบริษัทให้ถือเป็นที่สุดและไม่อาจโต้แย้งได้"
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("เงื่อนไขเป็นไปตามที่บริษัทกำหนด")])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "imageModal",
          staticClass: "image-modal",
          attrs: { "overlay-theme": "dark" }
        },
        [
          _c("div", { staticClass: "image-modal-content" }, [
            _c("img", {
              attrs: {
                src:
                  "https://beneat.s3-ap-southeast-1.amazonaws.com/news/news_1720162785768_51.png",
                alt: "img"
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a03b6ae", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a03b6ae","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/millionBookingCelebrate/Index.vue
// module id = 2417
// module chunks = 0